import React from 'react';
import { PrivyProvider } from '@privy-io/react-auth';
import { PRIVY_APP_ID, PRIVY_CONFIG } from '../config/privyConfig';

export default function WalletProvider({ children }) {
    return (
        <PrivyProvider appId={PRIVY_APP_ID} config={PRIVY_CONFIG}>
            {children}
        </PrivyProvider>
    );
}
